import {Effect, effect} from '@mazechazer/redux-loop'

export function navigate<T>(hash: string, action: T): Effect<T> {
    return effect(() => {
        window.location.hash = hash
        return Promise.resolve(action)
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Browser.ts